module.exports = __webpack_public_path__ + "img/banner7.b300c2d6.png";